import { render } from "./DDPrivacyNotice.vue?vue&type=template&id=b3f9d85c"
import script from "./DDPrivacyNotice.vue?vue&type=script&lang=js"
export * from "./DDPrivacyNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__